export const SUPPLIER_RISK_CLASSIFICATION = {
  VERY_LOW: 'very_low',
  LOW: 'low',
  MEDIUM: 'medium',
  HIGH: 'high',
  EXTREME: 'extreme',
} as const

export const SUPPLIERS_MANAGE_PERSONAL_DATA = {
  NONE: 'none',
  BASIC_IDENTIFICATION: 'basic_identification',
  FINANCIAL_DATA: 'financial_data',
  HEALTH_DATA: 'health_data',
  SPECIAL_CATEGORIES: 'special_categories',
  OTHER: 'other',
} as const

export const SUPPLIER_CATEGORIES = {
  NON_CRITICAL: 'non_critical',
  CRITICAL: 'critical',
} as const

// Values must match the DB check constraint: supplier_detail_source_check
export const SUPPLIER_SOURCES = {
  INTEGRATION: 'Integration',
  MICROSOFT_SSO: 'Microsoft SSO',
  GOOGLE_SSO: 'Google SSO',
  OKTA_SSO: 'Okta SSO',
  MANUAL: 'Manual',
} as const

// The Suppliers table's filter value for an unassigned supplier, and the CSV export's cell for
// the same. Not translated: it is a filter key the table matches on, not only a label.
export const NO_RESPONSIBLE_VALUE = 'No responsible'

export const SUPPLIER_CSV_SAMPLE_PATH = '/bulk-samples/suppliers-sample.csv'

export const SUPPLIER_CSV_HEADERS = [
  'name',
  'responsible',
  'website',
  'supplierContactName',
  'managePersonalData',
  'contract',
  'riskClassification',
  'category',
  'saas',
  'responseExpectations',
  'iso27001Soc2Url',
  'securityQuestionnaire',
  'reviewDate',
  'findingsEvaluation',
  'reviewStatus',
] as const
